export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "logo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logo"])}
      },
      "fr": {
        "logo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logo"])}
      }
    }
  })
}
